import React, { Component } from "react";
import { Trans } from "react-i18next";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { NavLink } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
//import Swiper from 'react-id-swiper';
import axios from "axios";
//import Cookies from 'universal-cookie';
import SideBar from "./SideBar";
import PaymentForm from "./PaymentForm";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next";
// import Cookies from 'universal-cookie';

import ls from "local-storage";
import { options } from "../../config/options";
//import {creditimg} from "../../assets/img/sub-3.png";
import Loader from "react-loader-spinner";
import { CAPTURE_EVENT } from "../../Services/PosthogService";

const creditimg = require("../../assets/img/wallet.png");
var QRCode = require("qrcode.react");

var stripePromise;
var private_key;

setTimeout(function () {
  private_key = localStorage.getItem("stripe_public_key");
  stripePromise = loadStripe(private_key);
  console.log("stripe" + private_key);
}, 6000);

class WalletPayment extends Component {
  constructor(props) {
    super(props);
    this.loggedIn = sessionStorage.getItem("loggedin");
    this.homeLink = this.homeLink.bind(this);
    this.paywallet = this.paywallet.bind(this);
    this.state = {
      wallet_amount: "",
      api_url: localStorage.getItem("api_url"),
      showNav3: false,
      user_details: "",
      currency_code: "",
      customer_id: "",
      modal4: false,
      lang: ls.get("LangKeySet") || options[0],
      langKey: ls.get("LangValue"),
      take_from_wallet: false,
      auto_renewal: false,
      payable_amount: 0,
      minus_wallet_amount: 0,
      disabled: false,
      modal5: false,
      modal6: false,
      modal7: false,
      cib_enabled: false,
      loading: "true",
    };
  }

  paywallet() {
    if (this.state.disabled) {
      return;
    }
    this.setState({
      disabled: true,
    });
    var datalist = new FormData();
    datalist.set("user_id", JSON.parse(localStorage.getItem("session_userid")));
    datalist.set("language", this.state.langKey);
    datalist.set("purchase_type", this.state.payment_type);
    datalist.set("auto_renewal", this.state.auto_renewal);
    if (this.state.payment_type == "premium") {
      datalist.set("id", JSON.parse(localStorage.getItem("selected_premium")));
    } else if (this.state.payment_type == "boost") {
      datalist.set(
        "id",
        JSON.parse(localStorage.getItem("selected_boostpremium"))
      );
    } else if (this.state.payment_type == "superlike") {
      datalist.set(
        "id",
        JSON.parse(localStorage.getItem("selected_superlikepremium"))
      );
    } else if (this.state.payment_type == "banner") {
      datalist.set("id", JSON.parse(localStorage.getItem("banner_id")));
    }
    console.log("......datalist id.......");
    console.log(localStorage.getItem("selected_premium"));

    let payment_properties = {
      properties: {
        user_email: this.state.email,
        user_age: this.state.age,
        user_name: this.state.user_name,
        user_id: this.state.user_id,
        user_location: this.state.location,
      },
    };

    if (this.state.payment_type == "premium") {
      CAPTURE_EVENT("premium_purchase_done", payment_properties);
    }

    if (this.state.payment_type == "boost") {
      CAPTURE_EVENT("boost_page_viewed", payment_properties);
    }

    if (this.state.payment_type == "superlike") {
      CAPTURE_EVENT("superlike_purchase_done", payment_properties);
    }

    axios({
      method: "post",
      url: this.state.api_url + "paywallet",
      data: datalist,
      config: {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        },
      },
    })
      .then((res) => {
        if (res.data.status === "true") {
          // console.log(res.data);return false;

          if (res.data.type == "premium") {
            this.setState({
              message: res.data.message,
            });
            this.setState({
              modal4: true,
            });
            localStorage.setItem("premium_popup", "1");
            localStorage.setItem("isrevealed", res.data.revealed_matches);
          } else if (
            res.data.message ==
            "Amount successfully paid, now your banner is ready to display"
          ) {
            this.setState({
              message: res.data.message,
            });
            this.setState({
              modal6: true,
            });
          } else {
            this.setState({
              message: res.data.message,
            });
            this.setState({
              modal4: true,
            });
          }
        } else {
          //alert(res.data.message);
          this.setState({
            message: res.data.message,
          });
          this.setState({
            modal4: true,
          });
          //this.props.history.push("/login");
        }
      })
      .catch((error) => {
        this.props.history.push("/login");
      });
  }
  homeLink() {
    this.setState({
      modal4: false,
    });
    this.props.history.push("/app");
    window.location.reload();
  }
  homeLink1() {
    this.setState({
      modal5: false,
    });
  }
  addDefaultSrc(ev) {
    ev.target.src = require("../../assets/img/howzu-logo-default.png");
  }

  closeModal(tabId) {
    this.setState({
      [tabId]: false,
    });
    if (tabId == "modal6") {
      this.props.history.push("../../app/Banner");
    }
  }

  get_product_info_from_props = () => {
    if (!this.props || this.props.location.paytype === undefined) {
      this.props.history.push("/app/Profile");
      return false;
    }
    console.log("pay_type", this.props.location.paytype);
    const payment_type = this.props.location.paytype.type
      ? this.props.location.paytype.type
      : "";

    this.setState({
      payment_type: payment_type,
    });

    console.log("PAY TYPE1=" + payment_type);
    var package_id;
    var price;
    var currency;
    var pay_url;
    var curr_price;
    if (localStorage.getItem("currency") != null) {
      if (payment_type == "premium") {
        package_id = JSON.parse(localStorage.getItem("selected_premium"));
        price = JSON.parse(localStorage.getItem("premium_price"));
        curr_price = JSON.parse(localStorage.getItem("currency_premium_price"));
        currency = JSON.parse(localStorage.getItem("currency"));
        // alert(package_id);
        console.log("selected_premiumm=" + package_id + price + currency);
        pay_url = "/app/Payment";
      } else if (payment_type == "boost") {
        package_id = JSON.parse(localStorage.getItem("selected_boostpremium"));
        price = JSON.parse(localStorage.getItem("boostpremium_price"));
        curr_price = JSON.parse(
          localStorage.getItem("currency_boostpremium_price")
        );
        currency = JSON.parse(localStorage.getItem("currency"));
        console.log("selected_premium=" + package_id + price + currency);
        pay_url = "/app/Boostpayment";
      } else if (payment_type == "superlike") {
        package_id = JSON.parse(
          localStorage.getItem("selected_superlikepremium")
        );
        price = JSON.parse(localStorage.getItem("superlikepremium_price"));
        curr_price = JSON.parse(
          localStorage.getItem("currency_superlikepremium_price")
        );
        currency = JSON.parse(localStorage.getItem("currency"));
        console.log("selected_premium=" + package_id + price + currency);
        pay_url = "/app/Superlikepayment";
      } else if (payment_type == "banner") {
        package_id = JSON.parse(localStorage.getItem("banner_id"));
        price = JSON.parse(localStorage.getItem("bannerprice"));
        curr_price = JSON.parse(localStorage.getItem("bannerprice"));
        currency = JSON.parse(localStorage.getItem("currency"));
        console.log("selected_premium=" + package_id + price + currency);
        pay_url = "/app/Superlikepayment";
      }
    }
    this.setState({
      currency: currency,
      currency_package_price: curr_price,
      payable_amount: curr_price,
    });
  };

  componentWillReceiveProps(nextProps) {
    console.log("matchhhhhhhhhhhhhhh:");

    this.get_product_info_from_props();
    this.setState({
      take_from_wallet: false,
      minus_wallet_amount: 0,
    });
  }

  componentDidMount() {
    this.get_product_info_from_props();
    let data = new FormData();
    data.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    data.append("language", this.state.langKey);

    axios({
      method: "post",
      url: this.state.api_url + "webprofile",
      data: data,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      if (res.data.status !== false) {
        const user_details = res.data.result;
        console.log("user_details", user_details);
        this.setState({
          wallet_amount: user_details.wallet_amount,
          cib_enabled: user_details.cib_enabled,
          terms: user_details.terms,
          termsdes: user_details.termsdes,
        });

        this.setState({
          user_details: user_details,
        });
      } else {
        this.props.history.push("/login");
      }
      this.setState({
        loading: "false",
      });
    });
  }
  togglecheckbox = () => {
    //alert('aler');
    var wallet_amount = parseFloat(this.state.wallet_amount);
    if (wallet_amount === 0) {
      this.setState({
        modal5: true,
        message: "Your wallet amount is empty!",
      });
      return false;
    }

    if (this.state.payable_amount != 0) {
      this.setState({
        auto_renewal: false,
      });
    }
    var currency_package_price = parseFloat(this.state.currency_package_price);
    var wallet_balance_amount = wallet_amount;
    var minus_wallet_amount = 0;
    this.setState(
      {
        take_from_wallet: !this.state.take_from_wallet,
      },
      () => {
        console.log("111111111111111111111111111111111111111111");
        console.log(this.state.take_from_wallet);
        console.log("111111111111111111111111111111111111111111");
        if (this.state.take_from_wallet === true) {
          if (currency_package_price > wallet_amount) {
            console.log("33333333333333333333333");
            var balance_payable_amount = currency_package_price - wallet_amount;
            wallet_balance_amount = 0;
            minus_wallet_amount = wallet_amount;
          } else {
            console.log("222222222222222222222222222");

            var balance_payable_amount = 0;
            wallet_balance_amount = wallet_amount - currency_package_price;
            minus_wallet_amount = currency_package_price;
          }
          var is_float =
            Number(balance_payable_amount) === balance_payable_amount &&
            balance_payable_amount % 1 !== 0;
          if (is_float === true) {
            balance_payable_amount = parseFloat(balance_payable_amount).toFixed(
              2
            );
          }
          this.setState({
            payable_amount: balance_payable_amount,
            wallet_balance_amount: wallet_balance_amount,
            minus_wallet_amount: minus_wallet_amount,
          });
        } else {
          console.log("444444444444444444444444444444444444444");
          this.setState({
            wallet_balance_amount: wallet_amount,
            payable_amount: currency_package_price,
            minus_wallet_amount: 0,
          });
        }
      }
    );
  };

  renewalcheckbox = () => {
    //alert('yes');

    if (this.state.auto_renewal === true) {
      this.setState({
        auto_renewal: false,
      });
    } else {
      this.setState({
        auto_renewal: true,
      });
    }
  };
  makepayment = () => {
    var currency_code = this.state.currency
      ? this.state.currency
      : JSON.parse(localStorage.getItem("currency"));
    var amount = this.state.payable_amount ? this.state.payable_amount : 0;
    var purchase_type = this.state.payment_type ? this.state.payment_type : "";
    var item_id = 0;
    let data = new FormData();
    data.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    data.append("language", this.state.langKey);
    data.append("currency_code", currency_code);
    data.append("amount", amount);
    data.append("purchase_type", purchase_type);
    data.set("auto_renewal", this.state.auto_renewal);
    if (purchase_type == "premium") {
      item_id = JSON.parse(localStorage.getItem("selected_premium"));
    } else if (purchase_type == "boost") {
      item_id = JSON.parse(localStorage.getItem("selected_boostpremium"));
    } else if (purchase_type == "superlike") {
      item_id = JSON.parse(localStorage.getItem("selected_superlikepremium"));
    } else if (purchase_type == "banner") {
      item_id = JSON.parse(localStorage.getItem("banner_id"));
    }

    let payment_properties = {
      properties: {
        user_email: this.state.email,
        user_age: this.state.age,
        user_name: this.state.user_name,
        user_id: this.state.user_id,
        user_location: this.state.location,
      },
    };

    if (this.state.payment_type == "premium") {
      CAPTURE_EVENT("premium_purchase_done", payment_properties);
    }

    if (this.state.payment_type == "boost") {
      CAPTURE_EVENT("boost_page_viewed", payment_properties);
    }

    if (this.state.payment_type == "superlike") {
      CAPTURE_EVENT("superlike_purchase_done", payment_properties);
    }

    data.append("item_id", item_id);
    axios({
      method: "post",
      url: this.state.api_url + "createstripepayurl",
      data: data,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      console.log(res);
      if (res.status === 200) {
        if (res.data.status == "false") {
          this.setState({
            message: res.data.message,
            modal5: true,
          });
        }

        if (res.data.status !== false) {
          if (res.data.url && res.data.url !== "") {
            localStorage.setItem(
              "for_stripe_payment_wallet_amount",
              this.state.wallet_amount && this.state.wallet_amount
            );
            localStorage.setItem(
              "for_stripe_payment_minus_wallet_amount",
              this.state.minus_wallet_amount && this.state.minus_wallet_amount
            );
            localStorage.setItem(
              "for_stripe_payment_wallet_balance_amount",
              this.state.wallet_balance_amount &&
                this.state.wallet_balance_amount
            );
            localStorage.setItem(
              "for_stripe_payment_payable_amount",
              this.state.payable_amount && this.state.payable_amount
            );
            localStorage.setItem(
              "for_stripe_payment_take_from_wallet",
              this.state.take_from_wallet && this.state.take_from_wallet
            );
            //localStorage.setItem('for_stripe_payment_auto_renewal', this.state.auto_renewal && this.state.auto_renewal);

            window.location.href = res.data.url;
          }
        } else {
          this.setState({
            message: "Something went wrong, try again!",
            modal5: true,
          });
        }
      } else {
        this.setState({
          message: "Something went wrong, try again!",
          modal5: true,
        });
      }
    });
  };

  renewalmakepayment = () => {
    var currency_code = this.state.currency
      ? this.state.currency
      : JSON.parse(localStorage.getItem("currency"));
    var amount = this.state.payable_amount ? this.state.payable_amount : 0;
    var purchase_type = this.state.payment_type ? this.state.payment_type : "";
    var item_id = 0;
    let data = new FormData();
    data.append("user_id", JSON.parse(localStorage.getItem("session_userid")));
    data.append("language", this.state.langKey);
    data.append("currency_code", currency_code);
    data.append("amount", amount);
    data.append("purchase_type", purchase_type);
    data.set("auto_renewal", this.state.auto_renewal);
    if (purchase_type == "premium") {
      item_id = JSON.parse(localStorage.getItem("selected_premium"));
    } else if (purchase_type == "boost") {
      item_id = JSON.parse(localStorage.getItem("selected_boostpremium"));
    } else if (purchase_type == "superlike") {
      item_id = JSON.parse(localStorage.getItem("selected_superlikepremium"));
    } else if (purchase_type == "banner") {
      item_id = JSON.parse(localStorage.getItem("banner_id"));
    }
    data.append("item_id", item_id);
    axios({
      method: "post",
      url: this.state.api_url + "createstripepayurl",
      data: data,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      console.log(res);
      if (res.status === 200) {
        if (res.data.status == "false") {
          this.setState({
            message: res.data.message,
            modal5: true,
          });
        } else if (res.data.status == "true" || res.data.status == true) {
          this.setState({
            modal7: true,
          });
        } else {
          this.setState({
            message: "Something went wrong, try again!",
            modal5: true,
          });
        }

        // if(res.data.status !== false) {

        //      this.setState({
        //         modal7: true
        //     });

        // } else {
        //     this.setState({
        //         message : 'Something went wrong, try again!',
        //         modal5 : true,
        //     });
        // }
      } else {
        this.setState({
          message: "Something went wrong, try again!",
          modal5: true,
        });
      }
    });

    //  this.setState({
    //                 modal7: true
    //             });
  };

  makecibpayment = () => {
    var currency_code = this.state.currency
      ? this.state.currency
      : JSON.parse(localStorage.getItem("currency"));
    var amount = this.state.payable_amount ? this.state.payable_amount : 0;
    var purchase_type = this.state.payment_type ? this.state.payment_type : "";
    var item_id = 0;
    const ndata = {
      amount: amount,
      purchase_type: purchase_type,
      currency_code: currency_code,
      wallet_amount: this.state.wallet_amount && this.state.wallet_amount,
      minus_wallet_amount:
        this.state.minus_wallet_amount && this.state.minus_wallet_amount,
      wallet_balance_amount:
        this.state.wallet_balance_amount && this.state.wallet_balance_amount,
      take_from_wallet:
        this.state.take_from_wallet && this.state.take_from_wallet,
      terms: this.state.terms,
      termsdes: this.state.termsdes,
    };

    // Access history from props and navigate to a new route with data
    this.props.history.push("/app/cibpay", ndata);
    // let data = new FormData();
    // data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
    // data.append('language', this.state.langKey);
    // data.append('currency_code', currency_code);
    // data.append('amount', amount);
    // data.append('purchase_type', purchase_type);
    // data.set('auto_renewal', this.state.auto_renewal);
    // if(purchase_type=='premium'){
    //     item_id = JSON.parse(localStorage.getItem('selected_premium'));
    // }
    // else if(purchase_type=='boost'){
    //     item_id = JSON.parse(localStorage.getItem('selected_boostpremium'));
    // }
    // else if(purchase_type=='superlike'){
    //     item_id = JSON.parse(localStorage.getItem('selected_superlikepremium'));
    // }
    // else if(purchase_type=='banner'){
    //     item_id = JSON.parse(localStorage.getItem('banner_id'));
    // }
    // data.append('item_id', item_id);
    // axios({
    //     method: 'post',
    //     url: this.state.api_url+'createcibpayurl',
    //     data: data,
    //     config: { headers: {'Content-Type': 'multipart/form-data' }}
    // }).then(res => {
    //     console.log(res);
    //     if(res.status === 200) {
    //         console.log("kkk");
    //         if(res.data.status == 'false'){
    //            this.setState({
    //                 message : res.data.message,
    //                 modal5 : true,
    //             });
    //         }

    //         if(res.data.status !== false) {
    //             console.log("1kkk");

    //             if(res.data.url && res.data.url !== '') {
    //                 console.log("2kkk");

    //                 localStorage.setItem('for_cib_payment_wallet_amount', this.state.wallet_amount && this.state.wallet_amount);
    //                 localStorage.setItem('for_cib_payment_minus_wallet_amount', this.state.minus_wallet_amount && this.state.minus_wallet_amount);
    //                 localStorage.setItem('for_cib_payment_wallet_balance_amount', this.state.wallet_balance_amount && this.state.wallet_balance_amount);
    //                 localStorage.setItem('for_cib_payment_payable_amount', this.state.payable_amount && this.state.payable_amount);
    //                 localStorage.setItem('for_cib_payment_take_from_wallet', this.state.take_from_wallet && this.state.take_from_wallet);
    //                 //localStorage.setItem('for_stripe_payment_auto_renewal', this.state.auto_renewal && this.state.auto_renewal);
    //                 console.log('......url',res.data.url)
    //                 window.location.href = res.data.url;
    //                 // window.open(
    //                 //     res.data.url,
    //                 //     '_blank' // <- This is what makes it open in a new window.
    //                 //   );
    //             }
    //         } else {
    //             this.setState({
    //                 message : 'Something went wrong, try again!',
    //                 modal5 : true,
    //             });
    //         }
    //     }
    //     else {
    //         this.setState({
    //             message : 'Something went wrong, try again!',
    //             modal5 : true,
    //         });
    //     }
    // });
  };
  render() {
    var style = {
      zIndex: 10,
      backgroundColor: "white",
      height: "100vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      //width:"100%",
      overflowY: "hidden",
    };
    const params = {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      spaceBetween: 1,
      rebuildOnUpdate: true,
    };

    const params2 = {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      slidesPerView: 3,
      slidesPerColumn: 1,
      breakpoints: {
        360: {
          slidesPerView: 3,
        },
        359: {
          slidesPerView: 2,
        },
      },
    };

    const downloadQRCode = () => {
      const qrCodeURL = document
        .getElementById("qrCodeEl")
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      console.log(qrCodeURL);
      let aEl = document.createElement("a");
      aEl.href = qrCodeURL;
      aEl.download = "wallet-QRcode.png";
      document.body.appendChild(aEl);
      aEl.click();
      document.body.removeChild(aEl);
    };

    if (this.state.loading === "false") {
      return (
        <div className="setting-page">
          <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg ">
            <div className="heading-left-top d-flex">
              <div className="align-self-center ">
                <div className="iconHolder align-self-center mr-1">
                  <div className="backGlow  d-block d-lg-none">
                    <div
                      className="sideBarToggler sidebarIcoPos"
                      onClick={() => this.setState({ showNav3: true })}
                    ></div>
                  </div>
                </div>
              </div>
              <span className="arrow-center align-self-center ml-1 bold-font">
                <Trans i18nKey="Payment">Payment</Trans>
              </span>
            </div>
            <div className="backGlow white-bg"></div>
            <div class="d-flex justify-content-between">
              <div class="d-flex">
                {/* <div  className="iconHolder">
                            <NavLink to={"/app/promotinaloffer"} >
                                <div className="backGlow">
                                    <div className="sidebarIcoPos coupongif align-self-center"></div>
                                </div>
                            </NavLink>
                            </div>
                            <div className="iconHolder align-self-center">
                            <NavLink to={"/app/wallethistory"} >
                                <div className="backGlow">
                                    <div className="sidebarIcoPos historyIcon align-self-center"></div>
                                </div>
                            </NavLink>
                            </div> */}
              </div>
            </div>
          </div>
          <div className="p-4">
            <section>
              <div class="d-flex align-items-center justify-content-between walletBorder">
                <div class="d-flex">
                  <div class="walletIcon"></div>
                  <div>
                    <p class="fsm mb-0">
                      <Trans i18nKey="Wallet">Wallet</Trans>
                    </p>
                    <p class="bold-font mb-0">
                      {this.state.wallet_amount && this.state.wallet_amount}{" "}
                      {this.state.currency && this.state.currency}
                    </p>
                  </div>
                </div>
                {/* {
                                this.state.wallet_amount && this.state.wallet_amount !== 0 ?
                                <div class="moneyStatus">
                                    <input
                                        type="checkbox"
                                        name="rGroup"
                                        id="w1"
                                        onChange={this.togglecheckbox}
                                        checked={this.state.take_from_wallet}
                                    />
                                    <label class="" for="w1"></label>
                                </div>
                                :
                                ''
                            } */}

                <div class="moneyStatus">
                  <input
                    type="checkbox"
                    name="rGroup"
                    id="w1"
                    onChange={this.togglecheckbox}
                    checked={this.state.take_from_wallet}
                  />
                  <label class="" for="w1"></label>
                </div>
              </div>

              <div class="d-flex align-items-center justify-content-between walletBorder">
                <p class="fsm mb-0">
                  <Trans i18nKey="Package amount">Package amount</Trans>
                </p>
                <p class="bold-font fsm mb-0">
                  {this.state.currency_package_price &&
                    this.state.currency_package_price}{" "}
                  {this.state.currency && this.state.currency}
                </p>
              </div>
              <div class="d-flex align-items-center justify-content-between walletBorder">
                <p class="fsm mb-0">
                  <Trans i18nKey="Wallet amount">Wallet amount</Trans>
                </p>
                <p class="bold-font fsm mb-0">
                  {this.state.minus_wallet_amount &&
                    this.state.minus_wallet_amount}{" "}
                  {this.state.currency && this.state.currency}
                </p>
              </div>
              <div class="d-flex align-items-center justify-content-between walletBorder">
                <p class="fsm mb-0">
                  <Trans i18nKey="Balance">Balance</Trans>
                </p>
                <p class="bold-font fsm mb-0">
                  {this.state.payable_amount && this.state.payable_amount}{" "}
                  {this.state.currency && this.state.currency}
                </p>
              </div>
              {this.state.cib_enabled !== "true" &&
              this.state.payment_type != "banner" &&
              this.state.payment_type != "superlike" &&
              this.state.payment_type != "boost" &&
              (this.state.payable_amount == 0 ||
                this.state.minus_wallet_amount == 0) ? (
                <div class="d-flex align-items-center justify-content-between">
                  <p class="fsm mb-0">
                    <Trans i18nKey="Auto renewal">Auto renewal</Trans>
                  </p>
                  <p class="bold-font fsm mb-0">
                    <div class="moneyStatus">
                      <input
                        type="checkbox"
                        name="rGroup1"
                        id="w2"
                        onChange={this.renewalcheckbox}
                        checked={this.state.auto_renewal}
                      />
                      <label class="" for="w2"></label>
                    </div>
                  </p>
                </div>
              ) : (
                ""
              )}

              <div className="w-100 mt-5">
                {this.state.payable_amount === 0 ? (
                  <button
                    class="btn-common d-flex mx-auto"
                    onClick={this.paywallet}
                    disabled={this.state.disabled}
                  >
                    <Trans i18nKey="Confirm Payment">Confirm Payment</Trans>
                  </button>
                ) : this.state.cib_enabled === "true" ? (
                  <button
                    class="btn-common d-flex mx-auto align-items-center"
                    onClick={this.makecibpayment}
                  >
                    <Trans i18nKey="EDAHABIA ">EDAHABIA </Trans>
                    <img
                      src={require("../../assets/img/cib.jpg")}
                      alt=""
                      className="cib"
                    />
                    <Trans i18nKey="CIB Payment">CIB Payment</Trans>
                  </button>
                ) : this.state.auto_renewal === true ? (
                  <button
                    class="btn-common d-flex mx-auto"
                    onClick={this.renewalmakepayment}
                  >
                    <Trans i18nKey="Proceed Payment">Proceed Payment</Trans>
                  </button>
                ) : (
                  <button
                    class="btn-common d-flex mx-auto"
                    onClick={this.makepayment}
                  >
                    <Trans i18nKey="Proceed Payment">Proceed Payment</Trans>
                  </button>
                )}
              </div>
            </section>
          </div>
          <Modal
            isOpen={this.state.modal4}
            toggle={this.homeLink}
            className="premiumPopup vertically-center apd5"
          >
            <ModalHeader toggle={this.homeLink}>
              <h4 class="modal-title" style={{ marginTop: "10px" }}>
                <Trans i18nKey={this.state.message}>{this.state.message}</Trans>
              </h4>
            </ModalHeader>
            <ModalBody>
              <div className="modal-body">
                <div class="d-flex justify-content-end">
                  <div class="mr-3">
                    <button
                      class="border-0 bg-white pink-color"
                      onClick={this.homeLink}
                    >
                      <Trans i18nKey="Ok">Ok</Trans>
                    </button>
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={this.state.modal6}
            toggle={this.closeModal.bind(this, "modal6")}
            className="premiumPopup vertically-center apd5"
          >
            <ModalHeader toggle={this.closeModal.bind(this, "modal6")}>
              <h4 class="modal-title" style={{ marginTop: "10px" }}>
                <Trans i18nKey={this.state.message}>{this.state.message}</Trans>
              </h4>
            </ModalHeader>
            <ModalBody>
              <div className="modal-body">
                <div class="d-flex justify-content-end">
                  <div class="mr-3">
                    <button
                      class="border-0 bg-white pink-color"
                      onClick={this.closeModal.bind(this, "modal6")}
                    >
                      <Trans i18nKey="Ok">Ok</Trans>
                    </button>
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>

          {/*<Modal isOpen={this.state.modal7} toggle={this.closeModal.bind(this, 'modal7')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={this.closeModal.bind(this, 'modal7')}><h4 class="modal-title" style={{'marginTop':"10px"}}></h4>Pay With Stripe for Auto Renewal</ModalHeader>
                    <ModalBody>
                        <div className="modal-body">

                         <form className="apd20" onSubmit={this.onSubmit}>
                         <div className="user-input-wrp amb25">
                                   <br/><br/>
                                     <input type="text" id="name" value={this.state.name} onChange={this.onChangeName}  className="inputText" placeholder=" " required />
                                    <span className="floating-label"><Trans i18nKey="Name">Name</Trans></span>
                                </div>

                        <div className="user-input-wrp amb25">
                                    <br /><br/>
                                    <input  type="email" id="email"  value={this.state.email} onChange={this.onChangeEmail}  className="inputText" required />
                                    <span className="floating-label"><Trans i18nKey="Email">Email</Trans></span>
                                </div>

                         <span className="floating-label"><Trans i18nKey="Card Details">Card Details</Trans></span><br/><br/>
                         <Elements stripe={stripePromise} >                               
                            <PaymentForm />
                        </Elements>    

                        <br />
                            <div class="d-flex justify-content-end">
                                <div class="mr-3">
                                  <button class="btn-common d-flex mx-auto" >Proceed Payment</button>
                                </div>
                            </div>
                             </form>
                        </div>

                    </ModalBody> 
                </Modal>*/}

          <Modal
            isOpen={this.state.modal7}
            toggle={this.closeModal.bind(this, "modal7")}
            className="premiumPopup vertically-center apd5"
          >
            <ModalHeader>
              <h4 class="modal-title" style={{ marginTop: "10px" }}></h4>Pay
              With Stripe for Auto Renewal
            </ModalHeader>
            <ModalBody>
              <div className="modal-body">
                <Elements stripe={stripePromise}>
                  <PaymentForm
                    currency_code={
                      this.state.currency
                        ? this.state.currency
                        : JSON.parse(localStorage.getItem("currency"))
                    }
                    amount={
                      this.state.payable_amount ? this.state.payable_amount : 0
                    }
                    purchase_type={
                      this.state.payment_type ? this.state.payment_type : ""
                    }
                    auto_renewal={this.state.auto_renewal}
                    language={this.state.langKey}
                  ></PaymentForm>
                </Elements>
              </div>
            </ModalBody>
          </Modal>

          <Modal
            isOpen={this.state.modal5}
            toggle={this.closeModal.bind(this, "modal5")}
            className="premiumPopup vertically-center apd5"
          >
            <ModalHeader toggle={this.closeModal.bind(this, "modal5")}>
              <h4 class="modal-title" style={{ marginTop: "10px" }}>
                <Trans i18nKey={this.state.message}>{this.state.message}</Trans>
              </h4>
            </ModalHeader>
            <ModalBody>
              <div className="modal-body">
                <div class="d-flex justify-content-end">
                  <div class="mr-3">
                    <button
                      class="border-0 bg-white pink-color"
                      onClick={this.closeModal.bind(this, "modal5")}
                    >
                      <Trans i18nKey="Ok">Ok</Trans>
                    </button>
                  </div>
                </div>
              </div>
            </ModalBody>
          </Modal>
          <div className="sidebarResp d-block d-lg-none">
            <SideNav
              showNav={this.state.showNav3}
              onHideNav={() => this.setState({ showNav3: false })}
              title={<div></div>}
              items={[<SideBar />]}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="loder-icon">
            <div style={style} id="loader">
              <Loader type="Bars" color="#ca2a1e" height={30} width={50} />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default withTranslation("translations")(WalletPayment);
